import { SelectListOption } from "./common.type";

export interface RatingDto {
  id: number;
  raterUserId: number;
  shiftId: number;
  rating: number;
  status: number;
  dtFirstName: string;
  dtLastName: string;
  raterFirstName: string;
  raterLastName: string;
  officeName: string;
  comments: string;
  shiftPosition: string;
  payRate: number;
  noShow: boolean;
  sickCall: boolean;
  shiftStartDateTime: Date;
  shiftEndDateTime: Date;
  startDateOnly: Date;
  lastModifiedDate: Date;
}

export interface RatingDataDto {
  ratingStatuses: SelectListOption[];
}

export class RatingFormDto {
  id = 0;
  raterUserId = 0;
  rating = 0;
  comments: string | null = null;
  status = 0;
  sickCall = false;
  noShow = false;
}